import { render, staticRenderFns } from "./VoucherBenefitModal.vue?vue&type=template&id=5def7db6&scoped=true"
import script from "./VoucherBenefitModal.vue?vue&type=script&lang=ts"
export * from "./VoucherBenefitModal.vue?vue&type=script&lang=ts"
import style0 from "./VoucherBenefitModal.vue?vue&type=style&index=0&id=5def7db6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5def7db6",
  null
  
)

export default component.exports